import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faDiscord, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

const contacts = [
    {
        id: 'email',
        icon: faEnvelope,
        text: 'amir.e@next-il.co.il',
        link: 'mailto:amir.e@next-il.co.il'
    },
    {
        id: 'instagram',
        icon: faInstagram,
        text: 'amir.eliz',
        link: 'https://www.instagram.com/amir.eliz/'
    },
    {
        id: 'discord',
        icon: faDiscord,
        text: 'ShiNxz#0001',
    },
]

export default contacts